import DoctorDetailComponent from "@components/DoctorDetailComponent/DoctorDetailComponent";
import styles from "./DoctorDetailPage.module.css";
import { useParams } from "react-router";
import useDoctor from "@hooks/useDoctor";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const DoctorDetailPage = () => {
  const { email } = useParams();
  const { handleGetDoctorById } = useDoctor();
  const { singleDoctorData } = useSelector((state) => state.doctor);

  useEffect(() => {
    if (email) {
      handleGetDoctorById(email);
    }
  }, [email]);

  return (
    <div className={styles.Wrapper}>
      <DoctorDetailComponent doctorData={singleDoctorData?.data[0]} />
    </div>
  );
};

export default DoctorDetailPage;
